<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M5 20h14v-2H5m14-9h-4V3H9v6H5l7 7 7-7z"/>
    </svg>
</template>

<script>
export default {
    name: 'DownloadIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
